import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_user_label = _resolveComponent("user-label")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode(" Requested "),
    _createVNode(_component_humanize_time, {
      time: _ctx.request.createdAt,
      class: "inline-block"
    }, null, 8, ["time"]),
    (_ctx.request.creator)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createTextVNode(" by "),
          _createVNode(_component_user_label, {
            user: _ctx.request.creator
          }, null, 8, ["user"])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(". ")
  ]))
}